import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'char2br',
  // pure: true,
})
export class Char2brPipe implements PipeTransform {
  constructor() { }

  transform(content: string, char: string): string {
    const pattern = new RegExp(char, 'g');
    return content.replace(pattern, '<br />');
  }

}
